module.exports = __webpack_public_path__ + "static/img/企业邮箱.b097ae0a.png";